import { ExpressionConstraint, JsExpressionConstraint, OclExpressionConstraint } from '../constraint.js';
import { Schema } from '../schema.js';
import { JsFilterDefinition, OclFilterDefinition, ProductDefinition } from '../DataSetService/yaml-models.js';
import { RecordKind } from '../record.js';

/***
 * Registry holding all filters
 */
export class FilterRegistry {
  private readonly filters: {
    expression: ExpressionConstraint,
    definition: OclFilterDefinition | JsFilterDefinition
  }[] = [];

  constructor(private schema: Schema) {
  }

  addFilter(filter: OclFilterDefinition) {
    this.filters.push(this.createExpressionConstraint(filter));
  }

  getFiltersForProductType(productType: ProductDefinition['type']): ExpressionConstraint[] {
    return this.filters
      .filter(c => c.definition.type === productType)
      .map(c => c.expression);
  }

  private createExpressionConstraint(filter: OclFilterDefinition | JsFilterDefinition) {
    if (filter.kind === RecordKind.OclFilter) {
      return {
        expression: new OclExpressionConstraint(filter.oclExpression, `"${filter.name}" filter is not satisfied`, this.schema),
        definition: filter
      };
    } else {
      const filterFn = new Function('self, root', filter.jsExpression) as (self: any, root: any) => boolean;
      return {
        expression: new JsExpressionConstraint(filterFn, `"${filter.name}" filter is not satisfied`),
        definition: filter
      }
    }
  }

  getFiltersByName(filterNames: string[]) {
    return this.filters.filter(f => filterNames.includes(f.definition.name));
  }
}
